/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sub_Signup_CodeInputs */

const en_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the 6-digit setup code we emailed you to finish setting your password.`)
};

const es_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce el código de configuración de 6 dígitos que te enviamos por correo para terminar de establecer tu contraseña.`)
};

const de_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie den 6-stelligen Einrichtungscode aus Ihrer E-Mail ein, um Ihr Passwort festzulegen.`)
};

const zh_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入我们通过电子邮件发送给你的 6 位设置码，以完成密码设置。`)
};

const ar_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل رمز الإعداد المكوّن من 6 أرقام الذي أرسلناه إلى بريدك الإلكتروني لإكمال تعيين كلمة المرور.`)
};

const fr_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez le code de configuration à 6 chiffres que nous vous avons envoyé par e-mail pour définir votre mot de passe.`)
};

const vi_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập mã thiết lập gồm 6 chữ số mà chúng tôi đã gửi qua email để hoàn tất việc đặt mật khẩu.`)
};

const sw_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka msimbo wa tarakimu 6 tuliokutumia kwa barua pepe ili kumaliza kuweka nenosiri lako.`)
};

const th_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรอกรหัสตั้งค่า 6 หลักที่เราส่งไปทางอีเมลเพื่อตั้งรหัสผ่านให้เสร็จสมบูรณ์`)
};

const bs_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unesite 6-cifreni kod za postavljanje koji smo vam poslali e-mailom da biste završili postavljanje lozinke.`)
};

const ja_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードの設定を完了するには、メールでお送りした6桁の設定コードを入力してください。`)
};

const ko_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호 설정을 완료하려면 이메일로 보내 드린 6자리 설정 코드를 입력하세요.`)
};

const pt_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite o código de configuração de 6 dígitos que enviamos para seu e-mail para terminar de definir sua senha.`)
};

const it_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il codice di configurazione a 6 cifre che ti abbiamo inviato via email per completare l'impostazione della password.`)
};

const sv_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange den 6-siffriga aktiveringskoden som vi mejlade dig för att ställa in ditt lösenord.`)
};

const nl_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer de 6-cijferige activatiecode in die we je hebben gemaild om je wachtwoord in te stellen.`)
};

const da_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast den 6-cifrede aktiveringskode, vi har sendt dig på e-mail, for at oprette din adgangskode.`)
};

const nb_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv inn den 6-sifrede aktiveringskoden vi sendte deg på e-post, for å fullføre oppsettet av passordet ditt.`)
};

const fi_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna 6-numeroinen aktivointikoodi, jonka lähetimme sähköpostiisi, niin voit asettaa salasanasi.`)
};

const pl_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisz 6-cyfrowy kod aktywacyjny, który wysłaliśmy e-mailem, aby dokończyć ustawianie hasła.`)
};

const ru_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите 6-значный код активации, который мы отправили вам по электронной почте, чтобы задать пароль.`)
};

const tr_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parolanızı belirlemeyi tamamlamak için size e-postayla gönderdiğimiz 6 haneli etkinleştirme kodunu girin.`)
};

const hi_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना पासवर्ड सेट करना पूरा करने के लिए हमारे द्वारा ईमेल किया गया 6 अंकों का सेटअप कोड दर्ज करें।`)
};

const id_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan kode aktivasi 6 digit yang kami kirim ke email Anda untuk menyelesaikan pengaturan kata sandi.`)
};

const ms_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan kod pengaktifan 6 digit yang kami e-mel kepada anda untuk melengkapkan tetapan kata laluan anda.`)
};

const cs_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte 6místný aktivační kód, který jsme vám poslali e-mailem, a dokončete nastavení hesla.`)
};

const el_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εισαγάγετε τον 6ψήφιο κωδικό ενεργοποίησης που σας στείλαμε με email για να ολοκληρώσετε τον ορισμό του κωδικού πρόσβασής σας.`)
};

const he_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזינו את קוד ההגדרה בן 6 הספרות ששלחנו לכם בדוא״ל כדי להשלים את הגדרת הסיסמה.`)
};

const af_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer die 6-syfer-opstelkode in wat ons aan jou gestuur het om jou wagwoord te stel.`)
};

const hu_auth_sub_signup_code = /** @type {(inputs: Auth_Sub_Signup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adja meg az e-mailben elküldött 6 jegyű aktiváló kódot a jelszava beállításának befejezéséhez.`)
};

/**
* | output |
* | --- |
* | "Enter the 6-digit setup code we emailed you to finish setting your password." |
*
* @param {Auth_Sub_Signup_CodeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_sub_signup_code = /** @type {((inputs?: Auth_Sub_Signup_CodeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sub_Signup_CodeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_sub_signup_code(inputs)
	if (locale === "de") return de_auth_sub_signup_code(inputs)
	if (locale === "zh") return zh_auth_sub_signup_code(inputs)
	if (locale === "ar") return ar_auth_sub_signup_code(inputs)
	if (locale === "fr") return fr_auth_sub_signup_code(inputs)
	if (locale === "vi") return vi_auth_sub_signup_code(inputs)
	if (locale === "sw") return sw_auth_sub_signup_code(inputs)
	if (locale === "th") return th_auth_sub_signup_code(inputs)
	if (locale === "bs") return bs_auth_sub_signup_code(inputs)
	if (locale === "ja") return ja_auth_sub_signup_code(inputs)
	if (locale === "ko") return ko_auth_sub_signup_code(inputs)
	if (locale === "pt") return pt_auth_sub_signup_code(inputs)
	if (locale === "it") return it_auth_sub_signup_code(inputs)
	if (locale === "sv") return sv_auth_sub_signup_code(inputs)
	if (locale === "nl") return nl_auth_sub_signup_code(inputs)
	if (locale === "da") return da_auth_sub_signup_code(inputs)
	if (locale === "nb") return nb_auth_sub_signup_code(inputs)
	if (locale === "fi") return fi_auth_sub_signup_code(inputs)
	if (locale === "pl") return pl_auth_sub_signup_code(inputs)
	if (locale === "ru") return ru_auth_sub_signup_code(inputs)
	if (locale === "tr") return tr_auth_sub_signup_code(inputs)
	if (locale === "hi") return hi_auth_sub_signup_code(inputs)
	if (locale === "id") return id_auth_sub_signup_code(inputs)
	if (locale === "ms") return ms_auth_sub_signup_code(inputs)
	if (locale === "cs") return cs_auth_sub_signup_code(inputs)
	if (locale === "el") return el_auth_sub_signup_code(inputs)
	if (locale === "he") return he_auth_sub_signup_code(inputs)
	if (locale === "af") return af_auth_sub_signup_code(inputs)
	if (locale === "hu") return hu_auth_sub_signup_code(inputs)
	return en_auth_sub_signup_code(inputs)
});